import type { Brand, Person } from './types.ts';
import { domainOf, lower } from './util.ts';

/**
 * Règle de résolution du lieu (charte) pour une adresse d'envoi :
 * 1. Adresse principale + lieu forcé sur la personne  -> lieu forcé
 * 2. Domaine de l'adresse d'envoi rattaché à un lieu   -> ce lieu
 * 3. Lieu forcé sur la personne                        -> ce lieu
 * 4. Lieu par défaut (is_default)                      -> ce lieu
 */
export function resolveBrand(person: Person, sendAsEmail: string, brands: Brand[]): Brand {
  if (brands.length === 0) throw new Error('Aucun lieu (brand) configuré');
  const byId = (id: string | null) => (id ? brands.find((b) => b.id === id) : undefined);
  const isPrimary = lower(sendAsEmail) === lower(person.primary_email);

  if (isPrimary) {
    const forced = byId(person.brand_id);
    if (forced) return forced;
  }
  const domain = domainOf(sendAsEmail);
  const byDomain = brands.find((b) => b.domains.map(lower).includes(domain));
  if (byDomain) return byDomain;

  const forced = byId(person.brand_id);
  if (forced) return forced;

  // Repli déterministe (ordre alphabétique des id) si aucune charte n'est marquée par défaut.
  return brands.find((b) => b.is_default) ?? [...brands].sort((a, b) => a.id.localeCompare(b.id))[0];
}
